import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ModalWindow } from 'view/components/panels'
import { RFQTicketContent } from './RFQTicketContent'
import { EmptyTicket, TicketContainer } from 'view/shared/ticket'
import { IntervalWrapper } from 'view/components/timers'
import { createNegotiationDetailSelector } from 'selectors/negotiations'
import { AuditDetail, NegotiationDetail, NegotiationStatus } from 'api'
import { getRFQTitle, getLiveStatusColor, isTerminalStatus } from '../shared/utils'
import { Locale, Translation } from 'locale'

interface RFQTicketBrowserProps {
  negotiationId: string
  ownOrder: boolean
  history?: boolean
  negotiationDetail?: NegotiationDetail | AuditDetail
  onClose?: () => unknown
}

const negotiationIdSelector = (_state: {}, ownProps: RFQTicketBrowserProps) => ownProps.negotiationId
const ownOrderSelector = (_state: {}, ownProps: RFQTicketBrowserProps) => ownProps.ownOrder
const historySelector = (_state: {}, ownProps: RFQTicketBrowserProps) => !!ownProps.history

const mapStateToProps = createStructuredSelector({
  negotiationDetail: createNegotiationDetailSelector(negotiationIdSelector, ownOrderSelector, historySelector)
})

export class RFQTicketBrowserComponent extends React.Component<RFQTicketBrowserProps> {
  render() {
    const { negotiationDetail } = this.props
    if (!negotiationDetail) {
      return (
        <ModalWindow title={''}>
          <TicketContainer statusColor="white" fixedSize={true}>
            <EmptyTicket>{Locale.translate(Translation.SC_NEGOTIATION_NOT_EXIST)}</EmptyTicket>
          </TicketContainer>
        </ModalWindow>
      )
    } else {
      return negotiationDetail.negotiation.status === NegotiationStatus.QUOTED ? (
        <IntervalWrapper render={this.renderTicket} />
      ) : (
        this.renderTicket()
      )
    }
  }

  renderTicket = () => {
    const negotiationDetail = this.props.negotiationDetail!

    return (
      <ModalWindow title={getRFQTitle(negotiationDetail)}>
        <TicketContainer
          statusColor={getLiveStatusColor(negotiationDetail, true)}
          completed={
            isTerminalStatus(negotiationDetail.negotiation.status) && negotiationDetail.negotiation.status !== NegotiationStatus.CANCELLED
          }
          fixedSize={true}>
          <RFQTicketContent negotiationDetail={negotiationDetail} showCloseButton={true} onClose={this.props.onClose} />
        </TicketContainer>
      </ModalWindow>
    )
  }
}

export default connect(mapStateToProps)(RFQTicketBrowserComponent)
